export default "__VITE_ASSET__BZegp1X5__"